import { render, staticRenderFns } from "./Certificazione-Details.vue?vue&type=template&id=12c56b67&scoped=true&"
import script from "./Certificazione-Details.vue?vue&type=script&lang=js&"
export * from "./Certificazione-Details.vue?vue&type=script&lang=js&"
import style0 from "./Certificazione-Details.vue?vue&type=style&index=0&id=12c56b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c56b67",
  null
  
)

export default component.exports